import React from 'react';
import cn from 'classnames';
import { Card } from 'reactstrap';
import styles from './styles.css';

const CustomerDetailCard = ({ className, name }) => {
  return (
    <Card className={cn(className, 'pv3')}>
      <div>
        <h3 className=" ph3 f4 mt0">{name}</h3>
        <div className={`flex ${styles.detail} ph3 pt3`}>
          <div className="tc flex-grow-1">
            <h5 className="f5 lt">Current orders</h5>
            <h6 className="b f4">0</h6>
          </div>
          <div className="tc flex-grow-1">
            <h5 className="f5 lt">Total orders</h5>
            <h6 className="b f4">0</h6>
          </div>
          <div className="tc flex-grow-1">
            <h5 className="f5 lt">Total spend</h5>
            <h6 className="b f4">0</h6>
          </div>
        </div>
      </div>
    </Card>
  );
};

export default CustomerDetailCard;



// WEBPACK FOOTER //
// ./src/components/customerDetailCard/customerDetailCard.jsx